import React, { useState } from "react";
import { Box, Button, Typography, useTheme, InputLabel, TextField, Select, MenuItem } from "@mui/material";
import SubHeader from "../../../../../components/SubHeader";
import DeductionList from "./DeductionList";
import styles from "./style";
import { Download, Add } from "@mui/icons-material";
import Modal from "../../../../../components/Modal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DeductionViewPage = ({ data, setOpen, handleDownload, total, page, setPage, handleDelete, handleFilter, openAddModal, setOpenAddModal, handleAddDeduction, item }) => {
  const theme = useTheme();
  const [date, setDate] = useState(dayjs());
  const [amount, setAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("Manual");
  const role = localStorage.getItem("role");
  const isEmployeeRole = role === "Employee" || role === "employee";

  const handleAmountChange = (e) => {
    const value = e.target.value;
    let numericValue = value.replace(/[^0-9.]/g, '');
    if (numericValue === '0' || numericValue === '0.') {
      return;
    }
    if (numericValue === '') {
      setAmount('');
      return;
    }
    const numValue = parseFloat(numericValue);
    if (!isNaN(numValue)) {
      if (numValue > 0 || (numericValue.endsWith('.') && numValue >= 0)) {
        setAmount(numericValue);
      }
    }
  };

  const handleSave = () => {
    if (amount && parseFloat(amount) > 1 && date && paymentMethod) {
      handleAddDeduction(item?._id, item?.employeeDetails?._id, parseFloat(amount), date.format('YYYY-MM-DD'), paymentMethod);
      setAmount("");
      setDate(dayjs());
      setPaymentMethod("Manual");
    }
  };

  const handleCloseModal = () => {
    setOpenAddModal(false);
    setAmount("");
    setDate(dayjs());
    setPaymentMethod("Manual");
  };

  return (
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={styles.heading}>{isEmployeeRole ? "My Deduction" : "Deduction"}</Typography>

        <Box display="flex">
          <Button
            variant="contained" color="success" sx={styles.checkoutBtn}
            onClick={() => setOpenAddModal(true)}
          >
            <Add />
            Add Deduction
          </Button>
          <Button
            sx={styles.exportBtn}
            onClick={handleDownload}
          >
            <Download />
            Export Pdf
          </Button>
        </Box>
      </Box>


      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader title={`${item?.employeeDetails?.personalInfo?.firstName} ${item?.employeeDetails?.personalInfo?.surName}`}
          search={true}
          sortBy={true}
          onchange={(e) => handleFilter(e)}
          filter={handleFilter}
          isShowFilter={false}
          handleSort={(e) => handleFilter("", e)} />
        <DeductionList page={page} total={total} setPage={setPage} data={data} handleDelete={handleDelete} setOpen={setOpen} />
      </Box>

      <Modal
        open={openAddModal}
        setOpen={handleCloseModal}
        disabled={!amount || parseFloat(amount) <= 0 || !date || !paymentMethod}
        btnText="Save"
        handleCheck={handleSave}
        title="Add Deduction"
      >
        <Box>
          <Box sx={styles.modalGrid}>
            <Box sx={{ flex: {xs: "1 1 100%", md: "1 1 50%"}, minWidth: 0 }}>
              <InputLabel sx={styles.label}>Date</InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ mt: 1 }}>
                  <DatePicker
                    value={date}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }}
                    sx={styles.calenderInput}
                    onChange={(newValue) => { setDate(newValue); }}
                  />
                </Box>
              </LocalizationProvider>
            </Box>
            <Box sx={{ flex: {xs: "1 1 100%", md: "1 1 50%"}, minWidth: 0 }}>
              <InputLabel sx={styles.label}>Amount</InputLabel>
              <TextField
                type="text"
                value={amount}
                onChange={handleAmountChange}
                placeholder="Enter amount "
                sx={styles.reason}
                inputProps={{
                  min: 1,
                  step: 0.01
                }}
              />
            </Box>
          </Box>
          <Box sx={{ mt: 2 }}>
            <InputLabel sx={styles.label}>Payment Method</InputLabel>
            <Select
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
              sx={{
                ...styles.reason,
                "& .MuiOutlinedInput-root": {
                  minHeight: "56.5px",
                  height: "56.5px",
                  "& .MuiSelect-select": {
                    py: 1,
                    display: "flex",
                    alignItems: "center"
                  }
                }
              }}
              displayEmpty
            >
              <MenuItem value="Manual">Manual</MenuItem>
            </Select>
          </Box>
        </Box>
      </Modal>

    </>
  );
};

export default DeductionViewPage;
